export default {
  text: 'We would like to be allowed to send you notifications when you have a booking or there are other things that concern you.',
  takeAction: 'Take action'
}